export const properties = {}

export const settings = {
  easings: {
    easeIn: [0.32, 0, 0.67, 0],
    easeOut: [0.33, 1, 0.68, 1],
    easeInOut: [0.65, 0, 0.35, 1],
  },
}
